import { createRouter, createWebHistory } from "vue-router";

// 定义路由
const routes = [
  {
    path: "/:pathMatch(.*)",
    redirect: "/",
    hidden: true
  },
  {
    path: "/",
    name: "index",
    component: () => import("../views/index/index.vue")
  },
  {
    path: "/list",
    name: "list",
    component: () => import("../views/index/list.vue")
  },
  {
    path: "/details",
    name: "details",
    component: () => import("../views/index/details.vue")
  },
  {
    path: "/usercenter/index",
    name: "usercenter",
    component: () => import("../views/usercenter/index.vue")
  },
  {
    path: "/usercenter/details",
    name: "usercenterdetails",
    component: () => import("../views/usercenter/details.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register/index.vue")
  },
  {
    path: "/promybox/index",
    name: "promybox",
    component: () => import("../views/promybox/index.vue")
  }
];

// 创建router实例
const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
